import { render, staticRenderFns } from "./forgotCaptcha.vue?vue&type=template&id=88a297c8&scoped=true"
import script from "./forgotCaptcha.vue?vue&type=script&lang=js"
export * from "./forgotCaptcha.vue?vue&type=script&lang=js"
import style0 from "./forgotCaptcha.vue?vue&type=style&index=0&id=88a297c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a297c8",
  null
  
)

export default component.exports